import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/services/theme.service';
import { UserService } from 'src/app/services/user.service';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.([a-zA-Z]{2,})$/;

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit, OnDestroy {

  showPassword: boolean = false;
  registerForm: any = FormGroup;
  submitted = false;
  warnMsg: any;
  clicked: boolean = false;
  isInIframe: boolean;
  requestCount: number = 0;
  lastRequestTime: number = 0;
  maxRequests: number = 3;
  cooldownSeconds: number = 60;
  remainingCooldown: number = 0;
  countdownInterval: any;
  exceededMessageShown: boolean = false;

  constructor(private formBuilder: FormBuilder, private router: Router, private userService: UserService,
    private themeService: ThemeService
    ) {
    this.isInIframe = this.themeService.isInIframe();
   }


  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
    });
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
  keyPress(event: any) {
    this.warnMsg = '';
  }
  get f() { return this.registerForm.controls; }
  
  startCooldownTimer(): void {
    // Clear any existing interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Start countdown
    this.remainingCooldown = this.cooldownSeconds;
    this.countdownInterval = setInterval(() => {
      const timeSinceRequest = (Date.now() - this.lastRequestTime) / 1000;
      this.remainingCooldown = Math.ceil(this.cooldownSeconds - timeSinceRequest);
      
      if (this.remainingCooldown <= 0) {
        this.remainingCooldown = 0;
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  isButtonDisabled(): boolean {
    // Button disabled if form is invalid or currently submitting
    if (this.registerForm.invalid || this.clicked) {
      return true;
    }
    
    // Permanently disable only after exceeded message has been shown (4th+ click)
    if (this.exceededMessageShown) {
      return true;
    }
    
    // Disable for cooldown period after each request
    if (this.lastRequestTime > 0 && this.requestCount < this.maxRequests) {
      const timeSinceRequest = (Date.now() - this.lastRequestTime) / 1000; // in seconds
      if (timeSinceRequest < this.cooldownSeconds) {
        return true;
      }
    }
    
    return false;
  }
  
  forgotPswrd() {
    // Check if max requests already reached (4th+ attempt)
    if (this.requestCount >= this.maxRequests) {
      this.warnMsg = 'You have exceeded the daily limit for password reset requests. Please try again tomorrow.';
      this.exceededMessageShown = true;
      return;
    }

    // Clear previous message before making API call
    this.warnMsg = '';
    this.clicked = true;
    const email = this.registerForm.value.email.toLowerCase();

    this.userService.forgotPassword(email).subscribe(
      (res: any) => {
        // Increment request counter and set last request time
        this.requestCount++;
        this.lastRequestTime = Date.now();
        
        // Show success message for all successful attempts (1st, 2nd, 3rd)
        this.warnMsg = 'You will receive an e-mail to ' + email + ' in few minutes with further instructions if you are a registered user.';
        
        // Start countdown timer only if haven't reached max yet (for 1st and 2nd attempts)
        if (this.requestCount < this.maxRequests) {
          this.startCooldownTimer();
        }
        
        this.clicked = false;
      },
      (err: any) => {
        // Show generic error message for failures
        this.warnMsg = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.clicked = false;
      }
    );
  }

}
